import { FunctionComponent } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Text } from '@conexasaude/hero-web'
import Icon from '@/components/HeroIcons'
import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './styles'
import { DeviceSuccessModalProps } from './types'

const DeviceSuccessModal: FunctionComponent<
  DeviceSuccessModalProps
> = props => {
  const { consultationId } = props

  const { closeModal } = useModalContext()
  const history = useHistory()
  const styles = useStyles()

  const handleConfirm = () => {
    if (consultationId) {
      history.push(`/meus-atendimentos/atendimento/${consultationId}`)

      return
    }

    history.push('/meus-atendimentos')
  }

  return (
    <Modal id="DEVICE_SUCCESS" onDismiss={closeModal}>
      <div css={styles.content}>
        <Icon name="user-holding-phone-success" width={'172'} />
        <Text variant="large" css={styles.text}>
          Tudo certo com o aparelho testado
        </Text>
      </div>
      <div css={styles.footer}>
        <Button onClick={handleConfirm}>Ir para consultas</Button>
      </div>
    </Modal>
  )
}

export { DeviceSuccessModal }
